<template>
    <div class="sm:grid sm:grid-cols-3 sm:gap-6 mt-2">
        <div class="sm:col-span-1">

            <div v-if="!image || !(data && data.url) || !model"
                 class="inline-flex justify-center items-center h-16 w-16 rounded-full overflow-hidden bg-gray-100">
                <font-awesome-icon :icon="image ? 'image' : 'file'" size="2x"/>
            </div>

            <div v-if="image && model && (data && data.url)">
                <img :src="data.url" alt="" class="max-w-full w-56 object-contain">
            </div>

            <div class="mt-2 rounded-md">
                <input
                    type="file"
                    ref="input"
                    class="hidden"
                    @change="upload"
                    :accept="accept">
                <SubmitButton
                    type="button"
                    :submitting="submitting"
                    @click.prevent="$refs.input.click()"
                    theme="plain">
                    {{ model ? 'Change' : 'Choose' }}
                </SubmitButton>
            </div>
        </div>
        <div class="mt-4 sm:mt-0 sm:col-span-2">
            <p v-if="model && data.original_file_name">
                {{ data.original_file_name }}
            </p>
            <button v-if="model" class="text-red-500 mt-2" @click.prevent="model = null">Remove</button>
            <InputError class="mt-1" :message="errorMessage"/>
        </div>
    </div>
</template>

<script>

import axios from "axios";
import {get} from "lodash";
import InputError from "@/Components/Form/InputError";
import FormInput from "@/Mixins/FormInput";
import Button from "@/Components/Button";
import SubmitButton from "@/Components/Form/SubmitButton";

export default {

    mixins: [FormInput],

    props: {
        image: {
            type: Boolean,
            default: false
        },
        url: {
            type: String,
            default: route('api.uploads.store')
        },
        file: {
            type: Object,
            default: () => ({})
        },
        accept: String,
    },

    data() {
        return {
            data: this.file || {},
            errorMessage: '',
            submitting: false
        };
    },

    components: {
        SubmitButton,
        Button,
        InputError
    },

    methods: {
        upload(e) {

            this.errorMessage = '';

            if (!e.target.files.length) return;

            let formData = new FormData(),
                file = e.target.files[0];

            formData.append('file', file)

            this.submitting = true;

            axios.post(this.url, formData)
                .then(({data}) => {
                    this.data = data;
                    this.model = data.id;
                })
                .catch((error) => {
                    this.errorMessage = get(error, 'response.data.errors.file[0]');

                    this.reset();
                })
                .then(() => this.submitting = false);
        },
        reset() {
            this.$refs.input.value = '';
        }
    },

    watch: {
        file(file) {
            if (Object.keys(this.data).length < 1) {
                this.data = file;
            }
        }
    }
};

</script>
